export const StatusProposta = {
  ANALISE: 'Analise',
  APROVADA: 'Aprovada',
  REPROVADA: 'Reprovada',
  REVOGADA: 'Revogada',
  EXPIRADA: 'Expirada',
} as const
export type TStatusProposta = (typeof StatusProposta)[keyof typeof StatusProposta]

export const assinaturaContratoEnum = {
  Eletronica: 'Eletronica',
  Impressa: 'Impressa',
} as const
export type TAssinaturaContratoEnum = (typeof assinaturaContratoEnum)[keyof typeof assinaturaContratoEnum]

export const formaPagamentoComissaoEnum = {
  PagaPelaPlaenge: 'PagaPelaPlaenge',
  PagaPeloCliente: 'PagaPeloCliente',
} as const
export type TFormaPagamentoComissaoEnum = (typeof formaPagamentoComissaoEnum)[keyof typeof formaPagamentoComissaoEnum]

export const ClienteRegimeCasamentoEnum = {
  SeparacaoTotalBens: 'SeparacaoTotalBens',
  ComunhaoParcialBens: 'ComunhaoParcialBens',
  ComunhaoUniversalBens: 'ComunhaoUniversalBens',
  SeparacaoLegal: 'SeparacaoLegal',
  SeparacaoObrigatoriaBens: 'SeparacaoObrigatoriaBens',
  SeparacaoConvencional: 'SeparacaoConvencional',
  ParticipacaoFinalNosAquestos: 'ParticipacaoFinalNosAquestos',
} as const
export type TClienteRegimeCasamentoEnum = (typeof ClienteRegimeCasamentoEnum)[keyof typeof ClienteRegimeCasamentoEnum]

export const tipoAssinaturaEnum = {
  Simples: 'Simples',
  Dupla: 'Dupla',
} as const
export type TTipoAssinaturaEnum = (typeof tipoAssinaturaEnum)[keyof typeof tipoAssinaturaEnum]

export const tipoDoCompradorEnum = {
  PessoaFisica: 'PessoaFisica',
  PessoaJuridica: 'PessoaJuridica',
} as const
export type TTipoDoCompradorEnum = (typeof tipoDoCompradorEnum)[keyof typeof tipoDoCompradorEnum]

export const tipoDoVinculoDoCompradorEnum = {
  MaePai: 'MaePai',
  Conjuge: 'Conjuge',
  Procurador: 'Procurador',
  Representante: 'Representante',
} as const
export type TTipoDoVinculoDoCompradorEnum =
  (typeof tipoDoVinculoDoCompradorEnum)[keyof typeof tipoDoVinculoDoCompradorEnum]

export const opcaoVagaEnum = {
  Pendente: 'Pendente',
  Padrao: 'Padrao',
  Customizada: 'Customizada',
} as const
export type TOpcaoVagaEnum = (typeof opcaoVagaEnum)[keyof typeof opcaoVagaEnum]

export const tipoEmolumentoEnum = {
  AlienacaoFiduciaria: 'AlienacaoFiduciaria',
  ContratoCompraVenda: 'ContratoCompraVenda',
} as const
export type TTipoEmolumentoEnum = (typeof tipoEmolumentoEnum)[keyof typeof tipoEmolumentoEnum]
